import React from 'react';

const Login: React.FC = () => {
	return <div>Login</div>;
};

export default Login;
